/**
 * @generated SignedSource<<6ded95127bd5043c78e51191efe11d6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubSettings_customer$data = {
  readonly memberships: {
    readonly count: number;
  } | null | undefined;
  readonly packages: {
    readonly count: number;
  } | null | undefined;
  readonly rainchecks: {
    readonly count: number;
  } | null | undefined;
  readonly squareLoyaltyAccount?: {
    readonly balance: number;
    readonly expiringPointDeadlines: ReadonlyArray<{
      readonly expiresAt: string;
      readonly id: string;
      readonly points: number;
    }>;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"GiftCardsModal_customer" | "useGetPackageNeedingAttention_customer">;
  readonly " $fragmentType": "ClubSettings_customer";
};
export type ClubSettings_customer$key = {
  readonly " $data"?: ClubSettings_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubSettings_customer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubSettings_customer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetPackageNeedingAttention_customer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GiftCardsModal_customer"
    },
    {
      "condition": "patronLoyalty",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareLoyaltyAccount",
          "kind": "LinkedField",
          "name": "squareLoyaltyAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareLoyaltyAccountExpiringPointDeadline",
              "kind": "LinkedField",
              "name": "expiringPointDeadlines",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "points",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "memberships",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "MEMBERSHIP"
        }
      ],
      "concreteType": "MemberPackageConnection",
      "kind": "LinkedField",
      "name": "memberPackages",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "memberPackages(type:\"MEMBERSHIP\")"
    },
    {
      "alias": "packages",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "STANDARD"
        }
      ],
      "concreteType": "MemberPackageConnection",
      "kind": "LinkedField",
      "name": "memberPackages",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "memberPackages(type:\"STANDARD\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RaincheckConnection",
      "kind": "LinkedField",
      "name": "rainchecks",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
})();

(node as any).hash = "82224f462dc75a01aedd0c4adffa892a";

export default node;
